const LIMITS_TYPE = {
  LINKS_PER_MONTH: "aliases_per_billing_month",
  CLICKS_PER_MONTH: "hits_per_billing_month",
  BRANDED_DOMAINS_SUBDOMAINS: "branded_domains_subdomains",
};

export default LIMITS_TYPE;
